const React = require('react')
const { Container, Row } = require('reactstrap')

const { FooterWebsiteColumn } = require('./websiteCoulumn.footer')
const { FooterContactUsColumn } = require('./contactUsColumn.footer')
const { FooterProductsColumn } = require('./productsColumn.footer')
const { FooterTermsAndPolicies } = require('./termAndPolicies.footer')

require('@styles/layouts/footer.style.css')

const Footer = () => {
    return (
        <footer className='box footer'>
            <Container>
                <Row className='footer-content'>
                    <FooterWebsiteColumn />
                    <FooterContactUsColumn />
                    <FooterProductsColumn />
                </Row>
                <FooterTermsAndPolicies />
            </Container>
        </footer>
    )
}

module.exports = { Footer }
